import { Loader, Stack } from 'braid-design-system';
import React from 'react';

const PageLoader = () => (
  <Stack space="gutter" align="center">
    <div data-testid="loader">
      <Loader />
    </div>
  </Stack>
);

export default PageLoader;
